import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { useLanguage } from "../i18n";

export function BlogPromoCard({ offer, placement = "mid" }) {
  const { t, regionName, fmt } = useLanguage();
  // Promo personalizzata da Admin → Marketing (sostituisce l'offerta automatica)
  if (offer?.custom) {
    const c = offer.custom;
    return (
      <div data-testid={`inline-custom-promo-card-${placement}`}
        className="relative my-8 overflow-hidden rounded-3xl bg-[#1E293B] text-white shadow-xl shadow-slate-200">
        <div className="absolute -right-14 -top-14 w-40 h-40 rounded-full bg-[#FF6B35]/20 blur-2xl" aria-hidden="true" />
        <div className="relative grid sm:grid-cols-[1fr_auto] gap-5 items-center p-6 sm:p-7">
          <div className="min-w-0">
            <div className="flex items-center gap-2 font-mono-t text-[9px] font-bold uppercase tracking-[0.25em] text-[#FFB08A]">
              <Sparkles className="w-3.5 h-3.5" /> {t("blog.promoKicker")}
            </div>
            <h3 className="mt-2 font-display font-extrabold text-xl sm:text-2xl tracking-tight text-balance">{c.title}</h3>
            {c.text && <p className="mt-1.5 text-sm text-slate-300">{c.text}</p>}
          </div>
          {c.cta && (
            <Link to={c.link || "/destinations"} data-testid={`inline-promo-buy-button-${placement}`}
              className="inline-flex w-fit items-center gap-2 rounded-full bg-[#FF6B35] px-5 py-2.5 font-mono-t text-[10px] font-bold uppercase tracking-[0.18em] text-white hover:bg-[#E8551F] transition-colors">
              {c.cta} <ArrowUpRight className="w-3.5 h-3.5" />
            </Link>
          )}
        </div>
      </div>
    );
  }
  if (!offer?.code) return null;
  const code = offer.code.toLowerCase();
  const country = regionName(offer.code);

  return (
    <div data-testid={`inline-esim-promo-card-${placement}`}
      className="relative my-8 overflow-hidden rounded-3xl bg-[#1E293B] text-white shadow-xl shadow-slate-200">
      <div className="absolute -right-14 -top-14 w-40 h-40 rounded-full bg-[#FF6B35]/20 blur-2xl" aria-hidden="true" />
      <div className="relative grid sm:grid-cols-[1fr_auto] gap-5 items-center p-6 sm:p-7">
        <div className="flex items-start gap-4 min-w-0">
          <img src={`https://flagcdn.com/w80/${code}.png`} alt="" loading="lazy"
            className="w-11 h-11 rounded-full object-cover border-2 border-white/20 shadow-lg shrink-0" />
          <div className="min-w-0">
            <div className="flex items-center gap-2 font-mono-t text-[9px] font-bold uppercase tracking-[0.25em] text-[#FFB08A]">
              <Sparkles className="w-3.5 h-3.5" /> {t("blog.promoKicker")}
            </div>
            <h3 className="mt-2 font-display font-extrabold text-xl sm:text-2xl tracking-tight text-balance">
              {t("blog.promoTitle").replace("{country}", country)}
            </h3>
            <p className="mt-1.5 text-sm text-slate-300">
              {t("blog.promoSub").replace("{price}", fmt(offer.min_price))}
            </p>
          </div>
        </div>
        <Link to={`/destination/${code}`} data-testid={`inline-promo-buy-button-${placement}`}
          className="inline-flex w-fit items-center gap-2 rounded-full bg-[#FF6B35] px-5 py-2.5 font-mono-t text-[10px] font-bold uppercase tracking-[0.18em] text-white hover:bg-[#E8551F] transition-colors">
          {t("blog.promoCta")} <ArrowUpRight className="w-3.5 h-3.5" />
        </Link>
      </div>
    </div>
  );
}
